<script>
  import BaseTable from './table';

  export default {
    components: {
      BaseTable,
    },

    props: {
      url: null,
    },

    data() {
      return {
        items: null,
        current: null,
        total: null,
        pageSize: null,
        currentPage: 1,
        isRefreshing: true,
      };
    },

    methods: {
      /**
       * @param {Array} items
       * @param {Number} total
       * @param {Number} currentPage
       * @param {Number} pageSize
       */
      onLoadSuccess({items, meta: {current_page: currentPage, per_page: pageSize, total}}) {
        this.items = items;
        this.total = total;
        this.currentPage = currentPage;
        this.pageSize = pageSize;
      },

      /**
       * @param {boolean} value
       */
      onRefresh(value) {
        this.isRefreshing = value;
      }
    },

  }
</script>

